import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgArrowDown = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.95633 16.2577V2H12.0437L12.0437 16.2577L16.524 12.0614L18 13.4438L11 20L4 13.4438L5.47597 12.0614L9.95633 16.2577Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgArrowDown);

export default ForwardRef;
